// frontend/src/components/ui/alert.jsx
import React from 'react';
import { cn } from '../../lib/utils';

const variantStyles = {
  default: "bg-background-secondary text-text-primary border border-border-primary",
  destructive: "bg-status-error-bg text-status-error-text border border-status-error-border",
  success: "bg-status-success-bg text-status-success-text border border-status-success-border",
  warning: "bg-status-warning-bg text-status-warning-text border border-status-warning-border",
  info: "bg-status-info-bg text-status-info-text border border-status-info-border",
};

export const Alert = ({ variant = "default", className, ...props }) => (
  <div
    role="alert"
    className={cn(
      "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
      variantStyles[variant] || variantStyles.default,
      className
    )}
    {...props}
  />
);

export const AlertTitle = ({ className, children, ...props }) => (
  <h5
    className={cn("mb-1 font-medium leading-none tracking-tight text-text-primary", className)}
    {...props}
  >
    {children}
  </h5>
);

export const AlertDescription = ({ className, ...props }) => (
  <div
    className={cn("text-sm [&_p]:leading-relaxed text-text-secondary", className)}
    {...props}
  />
);